// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelGuideBlock_root__auDPK","title":"TravelGuideBlock_title__tx7MJ"};